import { ShoppingBag, EyeOff } from "lucide-react";
import { FadeUp } from "../components/Reveal";
import { CornerWebs } from "../components/CornerWebs";
import { BRAND } from "../lib/content";

// HIDDEN PAGE — intentionally NOT linked in public navigation.
// Activate later by adding a { to: "/merch", label: "Shop" } entry to Navbar LINKS.

const PRODUCTS = [
  { name: "Journeys Tee — Black", price: "$34", tag: "Apparel" },
  { name: "Tattooed Abroad Hoodie", price: "$68", tag: "Apparel" },
  { name: "Flash Sheet Poster", price: "$28", tag: "Prints" },
  { name: "Enamel Sailor Star Pin", price: "$12", tag: "Accessories" },
  { name: "Season One Sticker Pack", price: "$9", tag: "Accessories" },
  { name: "Embroidered Web Cap", price: "$32", tag: "Apparel" },
];

export default function Merch() {
  return (
    <>
      <section className="relative overflow-hidden pt-36 pb-16">
        <CornerWebs />
        <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[600px] -translate-x-1/2 rounded-full bg-flame opacity-10 blur-[120px]" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10">
          <div data-testid="merch-hidden-notice" className="mb-8 inline-flex items-center gap-3 border border-yellow-500/40 bg-yellow-500/10 px-5 py-2.5">
            <EyeOff size={15} className="text-gold" />
            <span className="font-gothic text-xs uppercase tracking-[0.25em] text-gold">
              Hidden Page — Not in public navigation
            </span>
          </div>
          <FadeUp>
            <p className="font-gothic text-xs uppercase tracking-[0.35em] text-flame">Shop</p>
            <h1 className="mt-5 font-display text-5xl font-light tracking-tight text-white md:text-7xl">
              Merch<span className="text-fire">.</span>
            </h1>
            <p className="mt-6 max-w-2xl font-body text-lg leading-relaxed text-white/60">
              Wear the journey. Official Tattooed Abroad apparel, prints and accessories — ready to
              activate after the Kickstarter campaign.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {PRODUCTS.map((p, i) => (
              <FadeUp key={p.name} delay={(i % 3) * 0.08}>
                <div data-testid="merch-product" className="group border border-white/10 bg-surface/40 transition-colors hover:border-flame/60">
                  <div className="relative flex aspect-square items-center justify-center overflow-hidden bg-gradient-to-br from-surface to-ink">
                    <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                      <div className="absolute left-1/2 top-1/2 h-40 w-40 -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame opacity-25 blur-3xl" />
                    </div>
                    <img src={BRAND.initials} alt={p.name} className="w-1/2 opacity-40 transition-transform duration-500 group-hover:scale-110" />
                    <img src={BRAND.web} alt="" className="absolute right-2 top-2 w-10 opacity-15" />
                  </div>
                  <div className="flex items-center justify-between p-6">
                    <div>
                      <span className="font-gothic text-[10px] uppercase tracking-[0.3em] text-flame">{p.tag}</span>
                      <h3 className="mt-1 font-display text-lg text-white">{p.name}</h3>
                    </div>
                    <span className="font-stat text-xl font-bold text-white">{p.price}</span>
                  </div>
                  <button
                    data-testid="merch-add-to-cart"
                    disabled
                    className="flex w-full cursor-not-allowed items-center justify-center gap-2 border-t border-white/10 py-4 font-body text-xs uppercase tracking-[0.2em] text-white/40"
                  >
                    <ShoppingBag size={15} /> Available Soon
                  </button>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
